import React from "react";
import Loadable from "../../react-loadable";
import "./index.less";

const WeaHrmlist = Loadable({
  loader: () => import("./Hrmlist"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

export default WeaHrmlist;



// WEBPACK FOOTER //
// ./ecology9/wea-hrmlist/index.js